module.exports = __webpack_public_path__ + "DINNextLTPro-MediumCond.woff?3440122021679bfbef0d377e577ebe13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-MediumCond.woff
// module id = 1443
// module chunks = 0